import { render } from "./CreateVendor.vue?vue&type=template&id=fe223780&scoped=true"
import script from "./CreateVendor.vue?vue&type=script&lang=js"
export * from "./CreateVendor.vue?vue&type=script&lang=js"

import "./CreateVendor.vue?vue&type=style&index=0&id=fe223780&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe223780"]])

export default __exports__